import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import HvacOffer from "../../../assets/images/hvac_offer.png";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { useAppDispatch } from "../../../store/hook";
import { setMyProfileProps } from "../../../store/modules/meSlice";

const dialogPaperStyle = {
  display: { lg: "flex", xs: "block" },
  flexDirection: "row",
  borderRadius: 0,
  width: "1000px",
  maxWidth: { lg: "unset", xs: "100%" },
  height: { lg: "430px", xs: "auto" },
};

export const HvacOfferDialog = ({ open }: any) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setMyProfileProps({showPopup: null}))
  }

  const handleSubmit = () => {
    window.open("https://www.freedomhvac.us", '_blank')?.focus()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: dialogPaperStyle }}
    >
      <Box
        component="img"
        src={HvacOffer}
        alt="hvac offer"
        loading="lazy"
        sx={{ display: { lg: "block", xs: "none" } }}
      />

      <Stack
        sx={{
          height: '100%',
          flex: "auto",
          justifyContent: 'center',
          alignItems: "center",
          padding: "100px 5px",
          textAlign: "center",
          gap: "15px",
        }}
      >
        <Typography
          sx={{
            fontSize: { lg: "40px", xs: "14px" },
            lineHeight: { lg: "46.68px", xs: "16.34px" },
            fontWeight: 700,
            // maxWidth: "472px",
          }}
        >
          Freedom Power now offers HVAC Services
        </Typography>
        <Button
          LinkComponent="a"
          variant="contained"
          sx={{
            marginTop: "auto",
            borderRadius: "100px",
            width: { lg: "166px", xs: "166px" },
          }}
          onClick={handleSubmit}
          // target="_blank"
          // href="https://docs.google.com/forms/d/e/1FAIpQLSeyTO4Lo8ymhhkGEilyKqICYmlK1zC6ZDN6IufdBnoa6fRzWw/viewform?_hsenc=p2ANqtz-8RWU7WNgRJdztBt442wHmfCHRov_Ld62sD_flZ8fVxfkK5FmQ0hTth1goDmTnqNqIRx1Ek"
        >
          Learn More
        </Button>
      </Stack>

      <IconButton
        color="inherit"
        size="small"
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: { lg: "5px", xs: 0 },
          right: { lg: "5px", xs: 0 },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Dialog>
  );
};
